var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8335 2.79199H15.6668C16.2418 2.79199 16.7085 3.25866 16.7085 3.83366V6.75033C16.7085 7.09533 16.9885 7.37533 17.3335 7.37533C17.6785 7.37533 17.9585 7.09533 17.9585 6.75033V3.83366C17.9585 2.56866 16.9318 1.54199 15.6668 1.54199H9.8335C9.4885 1.54199 9.2085 1.82199 9.2085 2.16699C9.2085 2.51199 9.4885 2.79199 9.8335 2.79199Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6667 15.7087C16.9317 15.7087 17.9584 14.682 17.9584 13.417V6.33366C17.9584 5.06866 16.9317 4.04199 15.6667 4.04199C15.6667 4.04199 12.4167 4.04199 11.1567 4.04199C11.0817 4.04199 11.0117 4.00116 10.9751 3.93449C10.5742 3.21283 9.76842 1.76366 9.36758 1.04199C9.11092 0.579492 8.62258 0.291992 8.09342 0.291992H2.33341C1.06841 0.291992 0.041748 1.31866 0.041748 2.58366V13.417C0.041748 14.682 1.06841 15.7087 2.33341 15.7087H15.6667ZM15.6667 14.4587H2.33341C1.75841 14.4587 1.29175 13.992 1.29175 13.417V2.58366C1.29175 2.00866 1.75841 1.54199 2.33341 1.54199H8.09342C8.16842 1.54199 8.23841 1.58283 8.27508 1.64949C8.67591 2.37116 9.48175 3.82033 9.88258 4.54199C10.1392 5.00449 10.6276 5.29199 11.1567 5.29199H15.6667C16.2417 5.29199 16.7084 5.75866 16.7084 6.33366V13.417C16.7084 13.992 16.2417 14.4587 15.6667 14.4587Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b7596964cf0e7293e3fd8ad77dc42e15.svg";
export { ForwardRef as ReactComponent };